import { render, staticRenderFns } from "./PromoProduct.vue?vue&type=template&id=1f39532a&scoped=true&"
import script from "./PromoProduct.vue?vue&type=script&lang=ts&"
export * from "./PromoProduct.vue?vue&type=script&lang=ts&"
import style0 from "./PromoProduct.vue?vue&type=style&index=0&id=1f39532a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39532a",
  null
  
)

export default component.exports